import { IconButton } from '@c2fo/liquidity';
import { BarsIcon, CardsIcon } from '@c2fo/liquidity/icons';

export type ViewMode = 'list' | 'grid';

interface ListViewSwitchProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

export const ListViewSwitch: React.FC<ListViewSwitchProps> = ({ viewMode, onViewModeChange }) => {
  return (
    <div className="flex items-center border border-gray-200 rounded-md overflow-hidden">
      <IconButton
        icon={BarsIcon}
        name="List view"
        title="List View"
        onClick={() => onViewModeChange('list')}
        variant="link"
        size="sm"
        className={`rounded-none ${viewMode === 'list' ? 'bg-gray-100 [&_svg]:fill-gray-700' : '[&_svg]:fill-gray-400'}`}
      />
      <div className="w-px h-6 bg-gray-200" />
      <IconButton
        icon={CardsIcon}
        name="Grid view"
        title="Grid View"
        onClick={() => onViewModeChange('grid')}
        variant="link"
        size="sm"
        className={`rounded-none ${viewMode === 'grid' ? 'bg-gray-100 [&_svg]:fill-gray-700' : '[&_svg]:fill-gray-400'}`}
      />
    </div>
  );
};
